<div *ngIf="!showMailView" class="col-md-12">
  <form [formGroup]="paymentform">
    <div class="row">
      <div class="form-group col-md-2">
        <label for="date">Datum</label>
        <input type="text" class="form-control form-control-sm" id="date" style="min-width:120px;max-width:120px;" formControlName="date" format="YYYY-mm-dd" mask="0000-00-00" required>
      </div>
      <div class="form-group col-md-2">
        <label for="date">Belopp</label>
        <input type="text" class="form-control form-control-sm" id="amount" style="min-width:120px;max-width:120px;" formControlName="amount" required>
      </div>
      <div class="form-group col-md-3">
        <label>&nbsp;</label>
        <button class="btn border col-md-12" (click)="registerPayments()" [disabled]="(selectedmembers?.length===0 || !paymentform.valid || paymentInProgress)">Registrera
          betalning {{year}}</button>
      </div>
    </div>
  </form>
</div>
<div *ngIf="!showMailView" class="col-md-12">
  <p-table #dt [columns]="cols" [value]="memberpayments" [paginator]="false" dataKey="memberId" [autoLayout]="true" [loading]="loading" [filterLocale]="se" [resizableColumns]="true" rowExpandMode="multiple" [expandedRowKeys]="expandedRows" (onFilter)="onFilter($event, dt)">
    <ng-template pTemplate="caption">
      <div style="text-align: left;">Betalningar<span style="margin-left:50px;">Antal poster:
          {{filteredValues?.length}}<span style="text-align:right;">
            <button *ngIf="memberslist?.length > 0" class="btn border pull-right" style="margin-left:20px;" (click)="sendMail()">Epost</button>
            <button class="btn border pull-right" (click)="exportToExtendedCSV()">Excel</button>
          </span></span></div>
      <div class="pull-left" style="font-size:36px;color:#920000;">{{year}}</div>
      <br>
      <div style="text-align: right">
        <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
        <input #globalfilter type="text" pInputText size="50" placeholder="Globalt filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th><i class="fa fa-arrow-circle-o-right" *ngIf="expand" (click)="expandCollapse();expand = !expand" style="font-size:18px;padding:5px;" title="Öppna alla rader"></i>
          <i class="fa fa-arrow-circle-o-down" style="font-size:18px;padding:5px;" *ngIf="!expand" (click)="expandCollapse();expand = !expand" title="Stäng alla rader"></i>
        </th>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field" pResizableColumn class="no-highlight">
          <span *ngIf="col.field!=='x'">{{col.header}}</span>
          <p-sortIcon *ngIf="col.field!=='x'" [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
          </p-sortIcon>
          <span *ngIf="col.field==='x'"><button class="btn" (click)="selectAllFilteredRows()">Välj</button></span>
        </th>
      </tr>
      <tr>
        <th style="width: 1em">
          <i class="fa fa-filter" style="font-size:12px;margin-left:5px;font-weight:bold;" (click)="resetFilter();" title="Rensa filter"></i>
        </th>
        <th *ngFor="let col of columns" [ngSwitch]="col.field">
          <input *ngSwitchCase="'memberId'" pInputText type="text" [value]="dt.filters['memberId'] ? dt.filters['memberId'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <input *ngSwitchCase="'givenName'" pInputText type="text" [value]="dt.filters['givenName'] ? dt.filters['givenName'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <input *ngSwitchCase="'familyName'" pInputText type="text" [value]="dt.filters['familyName'] ? dt.filters['familyName'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <input *ngSwitchCase="'abbreviation'" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <input *ngSwitchCase="'shortName'" pInputText type="text" [value]="dt.filters['shortName'] ? dt.filters['shortName'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <p-select #fullypaid appendTo="body" *ngSwitchCase="'fullyPaid'" [options]="fullypaidlist" [autoWidth]="false" [style]="{'maxWidth':'100%'}" (onChange)="dt.filter($event.value, 'fullyPaid', 'equals')"></p-select>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-i="rowIndex" let-expanded="expanded" let-columns="columns" class="ui-resizable-column">
      <tr [pSelectableRow]="rowData" [ngClass]="{'exp': expanded, 'inactive': !rowData['isActiveMember'] && (rowData['institutionType']===5 || rowData['institutionType']===16)}">
        <td [ngClass]="{'inactive': !rowData['isActiveMember'] && (rowData['institutionType']===5 || rowData['institutionType']===16)}">
          <a *ngIf="rowData.payments?.length > 0" href="#" [pRowToggler]="rowData">
            <i [ngClass]="expanded ? 'fa fa-chevron-down' : 'fa fa-chevron-right'" style="font-size:10px;font-weight:bold;"><span style="margin-left:4px;color: grey;">{{rowData.payments?.length}}</span></i>
          </a>
        </td>
        <td *ngFor="let col of columns" style="height:40px;">
          <span *ngIf="col.field === 'memberId'"><a [routerLink]="['/memberform/id/', rowData[col.field]]">{{rowData[col.field]}}</a>
          </span>
          <span *ngIf="col.field === 'shortName'">
            <a [routerLink]="['/institutions/id/', rowData['primaryInstitution']?.id]" title="{{rowData[col.field]}} {{rowData['primaryInstitution'].name}}">{{rowData[col.field]}}</a>
          </span>
          <span *ngIf="(col.field!=='memberId' && col.field!=='fullyPaid' && col.field!=='x' && col.field!=='shortName')" [ngClass]="(col.field==='yearBalance' && rowData[col.field] < 0) ? 'red' : 'black'">{{rowData[col.field]}}</span>
          <span *ngIf="col.field !== 'x' && rowData[col.field] === true">
            <i class="fa fa-check" aria-hidden="true" style="color:green;"></i>
          </span>
          <span *ngIf="col.field !== 'x' && rowData[col.field] === false">
            <i class="fa fa-times" aria-hidden="true" style="color:red;"></i>
          </span>
          <span *ngIf="col.field === 'x'">
            <mat-checkbox style="width:10px;height:10px;" #ElInput (change)="add(rowData, ElInput);"></mat-checkbox>
          </span>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns">
      <tr>
        <td [attr.colspan]="columns.length + 1" style="background-color: white;">
          <table class="table table-border" style="margin-left:16px;width:98%;border:1px solid dodgerblue;">
            <thead>
              <tr>
                <th>Datum</th>
                <th>Belopp</th>
                <th style="width:50px;"></th>
              </tr>
            </thead>
            <tr *ngFor="let p of rowData.payments" class="paymentrow">
              <td>{{p.paidDate | date:'yyyy-MM-dd'}}</td>
              <td>{{p.paidAmount}}</td>
              <td style="border-left:1px solid lightgrey;">
                <i class="fa fa-trash" style="font-size:10px;" title="Radera" (click)="confirm(rowData, p)"></i>
                <i class="fa fa-edit" style="font-size:10px;margin-left:10px;" title="Ändra" (click)="edit(rowData, p.paymentId)"></i>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </ng-template>
  </p-table>
 
</div>

<p-dialog header="Ändra betalning" [(visible)]="displayeditdialog" [closable]="true" appendTo="body" position="center" modal="true" maximizable="true">
  <app-payment-edit [rowdata]="rowdata" [payment]="payment" (doSave)="savePayment($event)" (doCancel)="cancelEdit()">
  </app-payment-edit>
</p-dialog>

<div *ngIf="showMailView">
  <app-mail [memberlist]=memberslist (closeEmail)="closeEmail($event)"></app-mail>
</div>